import { render, staticRenderFns } from "./UpcommingCelebration.vue?vue&type=template&id=6e618dda&scoped=true"
import script from "./UpcommingCelebration.vue?vue&type=script&lang=js"
export * from "./UpcommingCelebration.vue?vue&type=script&lang=js"
import style0 from "./UpcommingCelebration.vue?vue&type=style&index=0&id=6e618dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e618dda",
  null
  
)

export default component.exports